import { Tabs as MantineTabs } from '@mantine/core';
import { ReactNode } from 'react';
import tabsClasses from './Tabs.module.css';

type Props = {
  children: ReactNode;
  defaultValue: string;
  variant: 'secondary'; // will require this field to be passed in until we have a primary variant
};
export default function Tabs({ variant, children, defaultValue }: Props) {
  return (
    <MantineTabs
      variant={variant}
      defaultValue={defaultValue}
      classNames={{
        root: tabsClasses.tabRoot,
        list: tabsClasses.tabsList,
        panel: tabsClasses.tabPanel,
        tab: tabsClasses.tab,
        tabLabel: tabsClasses.tabLabel,
        tabSection: tabsClasses.tabSection,
      }}
    >
      {children}
    </MantineTabs>
  );
}
